<template>

  <div class="full_page">

    <h1>{{customer_detail.customer_display_name}}</h1>

    <template v-if="customer_detail.lfb_has_account === 1">
      <h5 class="text-color-red">
        AR ${{customer_detail.total_due_title}} / Sales ${{customer_detail.total_spent_title}} / LFB Rewards {{customer_detail.lfb_reward_point}} / LFB Orders {{customer_detail.lfb_order_count}} / LFB Last {{customer_detail.lfb_last_order_date}}
      </h5>
    </template>
    <template v-else>
      <h5 class="text-color-red">
        AR ${{customer_detail.total_due_title}} / Sales ${{customer_detail.total_spent_title}}
      </h5>
    </template>

    {{customer_detail.customer.address}},
    {{customer_detail.customer.city}},
    {{customer_detail.customer.state}}
    {{customer_detail.customer.zipcode}} -
    ID: {{customer_detail.customer.customer_id}} -
    {{customer_detail.customer.license_number}}
    {{get_phone_formatted}}

    <div class="row">

      <div class="col-2">
        <template v-if="customer_detail.customer.is_onhold === 1">
          <button class ="action_button" @click="store_button_value('put_on_hold',0)">Remove OnHold</button>
        </template>
        <template v-else>
          <button  class ="action_button" @click="store_button_value('put_on_hold',1)">Put OnHold</button>
        </template>
      </div>

      <div class="col-2">
        <template v-if="customer_detail.customer.is_hidden === 1">
          <button  class ="action_button" @click="store_button_value('mark_hidden',0)">Unmark Hidden</button>
        </template>
        <template v-else>
          <button  class ="action_button" @click="store_button_value('mark_hidden',1)">Mark As Hidden</button>
        </template>
      </div>

      <div class="col-2">
        <template v-if="showInfoButtons === true">
          <button  class ="action_button" @click="set_info_button(false)">Hide Info Buttons</button>
        </template>
        <template v-else>
          <button  class ="action_button" @click="set_info_button(true)">Show Info Buttons</button>
        </template>
      </div>

      <div class="col-2">
        <template v-if="customer_detail.customer.list_color === 2">
          <button  class ="action_button" @click="store_button_value('mark_list_color',0)">Mark Line Default</button>
        </template>
        <template v-else>
          <button  class ="action_button" @click="store_button_value('mark_list_color',2)">Mark Line Red</button>
        </template>
      </div>

      <div class="col-2">
        <template v-if="customer_detail.customer.has_to_pay === 0">
          <button  class ="action_button" @click="store_button_value('has_to_pay',1)">Has To Pay</button>
        </template>
        <template v-else>
          <button  class ="action_button" @click="store_button_value('has_to_pay',0)">Doesn't have to pay</button>
        </template>
      </div>

      <div class="col-2">
        <button  class ="action_button" @click="store_button_value('just_called',null)">I Just Called</button>
      </div>

    </div>


    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      <th>Avg Sold Per Day</th>
      <th>Run Out Date</th>
      <th>Last Order</th>
      <th>Last Call</th>
      <th>Sales Rep</th>
      </thead>
      <tr>
        <template v-if="customer_detail.number_of_orders > 1">
          <td>{{customer_detail.total_qty_ordered_average_per_day}} = {{customer_detail.total_qty_ordered_except_last_order}} qty / {{customer_detail.first_order_to_second_last_order_days}} days</td>
        </template>
        <template v-else>
          <td>N/A</td>
        </template>

        <template v-if="customer_detail.number_of_orders > 1">
          <td>{{customer_detail.runs_out_date}} = {{customer_detail.runs_out_in_days}} days</td>
        </template>
        <template v-else>
          <td>N/A</td>
        </template>

        <template v-if="customer_detail.last_placed_order_date">
          <template v-if="customer_detail.number_of_orders > 1">
            <td>{{customer_detail.days_since_last_order}} days ago {{customer_detail.last_placed_order_date}}</td>
          </template>
          <template v-else>
            <td>{{customer_detail.days_since_last_order}} days ago {{customer_detail.first_placed_order_date}}</td>
          </template>
        </template>

        <td>{{customer_detail.customer.last_call_formatted}}</td>

        <td>{{customer_detail.sales_rep_display_name}}</td>
      </tr>
    </table>


    <table class="table table-bordered">
      <tbody>
      <tr v-for="line in customer_detail.qty_category_array" v-bind:key="line">
        <td v-for="data in line" v-bind:key="data">
          <template v-if="data.bold === 1">
            <div class="qty_bold">{{data.value}}</div>
          </template>
          <template v-else>
            {{data.value}}
          </template>
        </td>
       </tr>
      </tbody>
    </table>


    <table>
      <thead>
        <th>Buyer Name</th>
        <th>Store Phone</th>
        <th>Buyer Phone</th>
        <th>Buyer Email</th>
        <th v-if="customer_detail.customer.notes">LL Notes</th>
        <th v-if="customer_detail.customer.status_string">Status Info</th>
      </thead>
      <tr>
        <td><input
            size="30%"
            type="text"
            id="buyer_name"
            class="form-control"
            :value="customer_detail.customer.buyer_name"
            @input="customer_detail.customer.buyer_name = $event.target.value"
            @blur="set_customer_field (customer_detail.customer.customer_id,'buyer_name',customer_detail.customer.buyer_name)">
        </td>
        <td><input
            size="30%"
            type="text"
            id="store_phone"
            class="form-control"
            :value="customer_detail.customer.store_phone"
            @input="customer_detail.customer.store_phone = $event.target.value"
            @blur="set_customer_field (customer_detail.customer.customer_id,'store_phone',customer_detail.customer.store_phone)">
        </td>
        <td><input
            size="30%"
            type="text"
            id="buyer_phone"
            class="form-control"
            :value="customer_detail.customer.buyer_phone"
            @input="customer_detail.customer.buyer_phone = $event.target.value"
            @blur="set_customer_field (customer_detail.customer.customer_id,'buyer_phone',customer_detail.customer.buyer_phone)">
        </td>
        <td><input
            size="30%"
            type="text"
            id="buyer_email"
            class="form-control"
            :value="customer_detail.customer.buyer_email"
            @input="customer_detail.customer.buyer_email = $event.target.value"
            @blur="set_customer_field (customer_detail.customer.customer_id,'buyer_email',customer_detail.customer.buyer_email)">
        </td>
        <td>{{customer_detail.customer.notes}}</td>
        <td>{{customer_detail.customer.status_string}}</td>
      </tr>
    </table>

    <div class="graph_background">
      <line-chart ytitle="Sales $" prefix="$ " :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA','#000000']" :data=customer_detail.graph_data.amount></line-chart>
    </div>

    <div class="graph_background">
      <line-chart ytitle="Units" prefix="" :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA','#000000']" :data=customer_detail.graph_data.count></line-chart>
    </div>

    <template v-if="customer_detail.order_details.length > 0">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      <tr class="description_small">
        <th>#</th>
        <th>Order Date</th>
        <th>Ship Date</th>
        <th>Days </th>
        <th>Avg Qty</th>
        <th>Total Units</th>
        <th>Gummies</th>
        <th>Sours</th>
        <th>Pre-Roll</th>
        <th>Sleep</th>
        <th>Wonder</th>
        <th>HARD 8th</th>
        <th>Noah's</th>
        <th>7 PK</th>
        <th>14 PK</th>
        <th>1g's</th>
        <th>Rice</th>
        <th>Plant</th>
        <th>Poppy's</th>


<!--        <th>Status</th>-->
        <th>Info</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order_detail in customer_detail.order_details" v-bind:key="order_detail.id">
        <td>{{order_detail.position}}</td>
        <td>{{order_detail.day}}</td>
        <td>{{order_detail.ship_date}}</td>
        <td>{{order_detail.days_to_next_order}}</td>
        <td>{{order_detail.average_sold_to_next_order}}</td>

        <template v-if="order_detail.qty_other === 0">
          <td>{{order_detail.qty_total}}</td>
        </template>
        <template v-else>
          <td class="text-color-red">{{order_detail.qty_total}}</td>
        </template>

        <td>{{order_detail.qty_gummies}}</td>
        <td>{{order_detail.qty_sour}}</td>
        <td>{{order_detail.qty_preroll}}</td>
        <td>{{order_detail.qty_sleep}}</td>
        <td>{{order_detail.qty_wonder}}</td>
        <td>{{order_detail.qty_hard8th}}</td>
        <td>{{order_detail.qty_noahs}}</td>
        <td>{{order_detail.qty_7pk}}</td>
        <td>{{order_detail.qty_14pk}}</td>
        <td>{{order_detail.qty_1gs}}</td>
        <td>{{order_detail.qty_rice}}</td>
        <td>{{order_detail.qty_plant}}</td>
        <td>{{order_detail.qty_poppys}}</td>

<!--        <td>{{order_detail.status}}</td>-->

        <td>
        <template v-if="showInfoButtons === true">
          <template v-if="order_detail.samples_bartender === 0">
          <button @click="set_bartender_sample_flag(customer_detail.customer.customer_id,'samples_bartender',order_detail.id, 1)">Set Budtender Sample</button>
          </template>
          <template v-else>
            <button @click="set_bartender_sample_flag(customer_detail.customer.customer_id,'samples_bartender',order_detail.id, 0)">Remove Budtender Sample</button>
          </template>
        </template>
          <template v-else>
          <template v-if="order_detail.samples_bartender === 1">Budtender Sample</template>
          </template>
        </td>

      </tr>
      </tbody>
    </table>
    </template>

    <div class="form-group">
<!--      <label for="note">Note</label>-->
      <input type="text" id="note" class="form-control" v-model="customerData.new_note">
      <button class="notes_button" @click="store_note_in_database()">Add Note</button>
    </div>


    <table v-if="customer_detail.notes" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
<!--      <tr>-->
<!--        <th>Time</th>-->
<!--        <th>Note</th>-->
<!--      </tr>-->
      </thead>
      <tbody>
      <tr v-for="notes in customer_detail.notes" v-bind:key="notes.id">
        <td width="200">{{notes.date}}</td>
        <td align="LEFT">{{notes.note}}</td>
      </tr>
      </tbody>
    </table>



    <template v-if="customer_detail.details_ar.length > 0">
      <div class = "container">
        <br>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-2 rounded-border-gray">
            <span class="total">TOTAL INVOICES</span><br>
            <span class="quantity">{{customer_detail.all_invoices}}</span>
          </div>
          <div class="col-1"></div>
          <div class="col-2 rounded-border-gray">
            <span class="total">TOTAL PAID</span><br>
            <span class="quantity">{{customer_detail.all_paid_invoices}}</span>
          </div>
          <div class="col-1"></div>
          <div class="col-2 rounded-border-gray">
            <span class="total">TOTAL UNPAID</span><br>
            <span class="quantity text-color-red">{{customer_detail.total_invoices}}</span>
          </div>
        </div>
        <br>
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Invoice</th>
            <th>Days</th>
            <th>Payment Balance</th>
            <th>Due Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="invoice_detail in customer_detail.details_ar" v-bind:key="invoice_detail.id">
            <td>{{invoice_detail.position}}</td>
            <td>{{invoice_detail.order_short_id}}</td>
            <td>{{invoice_detail.days}}</td>
            <td>$ {{invoice_detail.payment_balance_formatted}}</td>
            <td>{{invoice_detail.payment_due_date_format_usa}}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td class="redbold">TOTAL DUE &nbsp; {{customer_detail.total_due}}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>


  <br>
  <br>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      customerData: {
        new_note: '',
      },
      showInfoButtons: false,
    }
  },
  computed: {
    ...mapGetters({
      customer_detail: 'admin/customer_detail',
    }),
    get_phone_formatted() {
      if(this.customer_detail.customer.phone.length === 10) {
        return " - Phn (" + this.customer_detail.customer.phone.slice(0, 3) + ") " + this.customer_detail.customer.phone.slice(3, 6) + "-" + this.customer_detail.customer.phone.slice(6.10);
      }
      return this.customer_detail.customer.phone;
    },
  },
  props: {
    customer_id: null,
    is_noah: null,
  },
  mounted() {
    this.CustomerDetail();
  },
  destroyed() {
    this.$store.dispatch('admin/emptyDetailPage');
  },
  methods: {
    CustomerDetail () {
      this.$store.dispatch('admin/getCustomerDetail', {'customer_id': this.customer_id, 'is_noah': this.is_noah});
    },
    store_note_in_database() {
      this.$store.dispatch('admin/addNewCustomerNote', {'customer_id': this.customer_id, 'note': this.customerData.new_note, 'is_noah': this.is_noah});
      this.customerData.new_note = "";
    },
    set_customer_field (customer_id,fieldname,value) {
      this.$store.dispatch('admin/setCustomerField', {'is_noah': this.is_noah, customer_id,fieldname,value})
    },
    store_button_value (function_button, value) {

      if(function_button === 'mark_hidden') {
        this.$store.dispatch('admin/emptyLoadedLists');
      }
      if(function_button === 'mark_list_color') {
        this.$store.dispatch('admin/emptyLoadedLists');
      }
      if(function_button === 'has_to_pay') {
        this.$store.dispatch('admin/emptyLoadedLists');
      }

      this.$store.dispatch('admin/setButtonValue', {'customer_id': this.customer_id, 'is_noah': this.is_noah, function_button,value})
    },
    set_bartender_sample_flag(customer_id, fieldname,  order_id, value) {
    // todo: function 0/1 by day and customer
      this.$store.dispatch('admin/setOrderFlagValue', {'is_noah': this.is_noah, customer_id, fieldname, order_id, value})
    },
    set_info_button(value) {
      this.showInfoButtons = value;
    },
  }
}

</script>

<style scoped>


.qty_bold {
  font-weight: 700;
}

.description_small {
  font-size: smaller;
}

div.rounded-border-gray
{
  padding: 5px;
  border-radius: 30px;
  border: 10px solid #999;
  -moz-border-radius: 15px;
}

.redbold {
  color:red;
  font-weight: bold;
}

.total {
  font-weight: bold;
  font-size: 18px;
}

.quantity {
  font-weight: bold;
  font-size: 60px;
}

.text-color-red {
  color:red;
}

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.graph_background {
  border-radius: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10pX;
  background: #FFF;
}

.action_button {
  color: black;
  background-color: lightskyblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 12px;
  margin-bottom: 15px;
}

.notes_button {
  color: black;
  background-color: lightskyblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-size: larger;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 7px;
}

</style>

